module.exports = __webpack_public_path__ + "static/img/icon-club-adel.4c67568.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-club-adel.svg
// module id = m3zt
// module chunks = 0